import { render, staticRenderFns } from "./BaseShare.vue?vue&type=template&id=56b52e82&scoped=true"
import script from "./BaseShare.vue?vue&type=script&lang=js"
export * from "./BaseShare.vue?vue&type=script&lang=js"
import style0 from "./BaseShare.vue?vue&type=style&index=0&id=56b52e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b52e82",
  null
  
)

export default component.exports